import trunkStatusCodeToText from 'utils/trunkStatusCodeToText';

// Trunk status codes, as the Cloud SIP cards colour them.
const SIP_TRUNK_STATUS_COLORS = {
    0: 'green', // OK
    1: 'green', // Adding
    3: 'green', // Pending Approval
    4: 'green', // Updating
    8: 'yellow', // Degraded
    9: 'green', // Deleting
    20: 'red', // Error
};

/**
 * A Cloud SIP card's (SBCaaS or Cloud SIP Trunks) pill status from a trunk
 * status code. Green reads "Healthy". Degraded and Error name the trunk
 * status, which a pill without a label would leave blank.
 *
 * @param {?number} [statusCode] - trunk status, 0 (OK) to 20 (Error)
 * @returns {{ color?: string, statusLabel?: string }}
 */
const getSipTrunkCardStatus = (statusCode) => {
    const color = SIP_TRUNK_STATUS_COLORS[statusCode];
    return {
        color,
        statusLabel:
            color && color !== 'green'
                ? trunkStatusCodeToText(statusCode)
                : undefined,
    };
};

export default getSipTrunkCardStatus;
